//package imports 
import React, { useEffect, useState } from "react";
import { useRouteMatch, useHistory } from "react-router-dom";

//componenet imports
import { CusotomSearch } from "../../utils/resuableComponents/CustomSearch";
import CustomTable from "../../utils/resuableComponents/CustomTable";
import OrderRequestViewModal from "../../utils/resuableComponents/OrderRequestViewModal";
import {orderNewRequest} from "../../services/apiServices/GetServices";
import { getData } from "../../utils/AsyncStorage";
import {orderRequest} from "../../utils/constants/TableHeader";
import Loader from "../loadingScreens/Loader";


const OrderRequest = (props) => {
    const { role } = JSON.parse(getData("userInfo") || 0);
    const [filteredData, setFilteredData] = useState([])
    const [storeData, setStoreData] = useState([])
    const [storeTabToggle,setStoreTabToggle]=useState(1)
    const [searchTerm, setSearchTerm] = useState('');
    const [modal,setModal]=useState(false)
    const [modalData,setModalData]=useState([])
    const [subHeading,setSubHeading]=useState("")
    const [isLoader,setIsLoader]=useState(false)
    const history = useHistory();
    const pathName = undefined

    useEffect(() => {
        if(storeTabToggle===1){
            getNewOrderListApi()
            setSubHeading("New Request")
            setSearchTerm("")
        }else{
            getOldOrderListApi()
            setSubHeading("Old Request")
            setSearchTerm("")
        }
    }, [storeTabToggle]);

     //function to call api of the getUserList
     const getNewOrderListApi = async () => {
        setIsLoader(true)
        const res = await orderNewRequest("order/new");
        if (res.success) {
            // setFilteredData(res?.data)
            const newData = res?.data
            if(storeTabToggle === 1){
                setFilteredData(newData)
                setStoreData(newData)
            }
        } else {
            console.log("res", res?.message)
        }
    }

    //function call to handle close modal
    const handleClose = () => {
        setModal(false)
    }

    //function call to open modal
    const handleOpen = (data) => {
        setModalData(data)
        setModal(true)
    }

      //function to call api of the getUserList
      const getOldOrderListApi = async () => {
       setIsLoader(true)
        const res = await orderNewRequest("order/old");
        if (res.success) {
            const oldOrderData = res?.data
                setFilteredData(oldOrderData)
                setStoreData(oldOrderData)
        } else {
            console.log("res", res?.message)
        }
    }

    //function to handle tab
    const handleTabPublishedStore = () => {
      setStoreTabToggle(1)
    } 
    
    //function to handle tab onclick
    const handleTabDraftStore = () => {
        setStoreTabToggle(0)
      } 


    //function to hanlde search
    const handleSearch = (val) => {
        const searchVal = val
        if (searchVal === "") {
            if(storeTabToggle===1){
                getNewOrderListApi()
            }else{
                getOldOrderListApi()
            }
        } else {
            setSearchTerm(searchVal);
            const filterdata = storeData.filter((item) => {
                if (item?.name.toLowerCase()
                    .includes(searchVal.toLowerCase()) || item?.phone_number.includes(searchVal)) { return item; }
            })
            // //   setData(filterdata);
            setFilteredData(filterdata)
        }
    }

    return (
        <div class="col-md-12 " >
            {isLoader ? <Loader/> : null}
        <div class="d-flex w-50 flex-row  align-items-center w-100 border-bottom p-2">
            <h1 class="fs-4 ms-3 Montserrat fw-semi-bold">
            Order Request    
            </h1>
            <h6 class="h-25 m-0 fs-6 roboto fw-semi-bold">
            <i class="fas fa-chevron-right fa-xs mx-1"></i>
             {`${subHeading}`}
            </h6>
        </div>
        
        <hr class="hr w-100 m-0" />

        <OrderRequestViewModal open={modal} close={handleClose} data={modalData} from ={"orderRequest"} heading={storeTabToggle === 1 ? "New Request Details" : "Old Request Details"}  />
        <div class="d-flex">
            <div class="d-flex  w-75">
             <div class={storeTabToggle === 1 ?"mx-4 roboto tabBorder  h-50 my-2 align-self-end pointer" :"mx-4 roboto  h-50 my-2 align-self-end pointer"  } onClick={handleTabPublishedStore}>
                <h5 class= {storeTabToggle === 1 ? "fw-bold m-0 " : "status-pending m-0"}>New Request</h5>
             </div>
             <div class={storeTabToggle === 0 ? " roboto tabBorder pointer align-self-end  h-50 my-2" :" roboto pointer align-self-end  h-50 my-2" } onClick={handleTabDraftStore}>
                <h5 class={storeTabToggle === 0 ?"fw-bold m-0 " : "status-pending m-0"}>Old Request</h5>
             </div>
             </div>
             <CusotomSearch onChange={handleSearch} searchVal={searchTerm}  />
        </div>
        <CustomTable  path={pathName} data={filteredData} columnHeader={orderRequest} onClickAction ={handleOpen} from ={"orderRequest"} heading= "Detail View - Order Request" />
    </div>
    )
}

export default OrderRequest